export default "__VITE_ASSET__b378e5cb__"